!function (t, n) {
  "object" == typeof exports && "object" == typeof module ? module.exports = n() : "function" == typeof define && define.amd ? define("entitlements", [], n) : "object" == typeof exports ? exports.entitlements = n() : t.entitlements = n();
}(window, function () {
  return function (t) {
    var n = {};

    function e(r) {
      if (n[r]) return n[r].exports;
      var o = n[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return t[r].call(o.exports, o, o.exports, e), o.l = !0, o.exports;
    }

    return e.m = t, e.c = n, e.d = function (t, n, r) {
      e.o(t, n) || Object.defineProperty(t, n, {
        enumerable: !0,
        get: r
      });
    }, e.r = function (t) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    }, e.t = function (t, n) {
      if (1 & n && (t = e(t)), 8 & n) return t;
      if (4 & n && "object" == typeof t && t && t.__esModule) return t;
      var r = Object.create(null);
      if (e.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: t
      }), 2 & n && "string" != typeof t) for (var o in t) {
        e.d(r, o, function (n) {
          return t[n];
        }.bind(null, o));
      }
      return r;
    }, e.n = function (t) {
      var n = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };
      return e.d(n, "a", n), n;
    }, e.o = function (t, n) {
      return Object.prototype.hasOwnProperty.call(t, n);
    }, e.p = "", e(e.s = 12);
  }([function (t, n, e) {
    t.exports = e(11);
  }, function (t, n) {
    t.exports = function (t, n) {
      if (!(t instanceof n)) throw new TypeError("Cannot call a class as a function");
    };
  }, function (t, n) {
    function e(t, n) {
      for (var e = 0; e < n.length; e++) {
        var r = n[e];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    t.exports = function (t, n, r) {
      return n && e(t.prototype, n), r && e(t, r), t;
    };
  }, function (t, n) {
    t.exports = function (t, n, e) {
      return n in t ? Object.defineProperty(t, n, {
        value: e,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[n] = e, t;
    };
  }, function (t, n, e) {
    var r = e(8),
        o = e(9),
        i = e(10);

    t.exports = function (t) {
      return r(t) || o(t) || i();
    };
  }, function (t, n, e) {
    var r = e(3);

    t.exports = function (t) {
      for (var n = 1; n < arguments.length; n++) {
        var e = null != arguments[n] ? arguments[n] : {},
            o = Object.keys(e);
        "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(e).filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        }))), o.forEach(function (n) {
          r(t, n, e[n]);
        });
      }

      return t;
    };
  }, function (t, n, e) {
    window, t.exports = function (t) {
      var n = {};

      function e(r) {
        if (n[r]) return n[r].exports;
        var o = n[r] = {
          i: r,
          l: !1,
          exports: {}
        };
        return t[r].call(o.exports, o, o.exports, e), o.l = !0, o.exports;
      }

      return e.m = t, e.c = n, e.d = function (t, n, r) {
        e.o(t, n) || Object.defineProperty(t, n, {
          enumerable: !0,
          get: r
        });
      }, e.r = function (t) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
          value: "Module"
        }), Object.defineProperty(t, "__esModule", {
          value: !0
        });
      }, e.t = function (t, n) {
        if (1 & n && (t = e(t)), 8 & n) return t;
        if (4 & n && "object" == typeof t && t && t.__esModule) return t;
        var r = Object.create(null);
        if (e.r(r), Object.defineProperty(r, "default", {
          enumerable: !0,
          value: t
        }), 2 & n && "string" != typeof t) for (var o in t) {
          e.d(r, o, function (n) {
            return t[n];
          }.bind(null, o));
        }
        return r;
      }, e.n = function (t) {
        var n = t && t.__esModule ? function () {
          return t.default;
        } : function () {
          return t;
        };
        return e.d(n, "a", n), n;
      }, e.o = function (t, n) {
        return Object.prototype.hasOwnProperty.call(t, n);
      }, e.p = "", e(e.s = 85);
    }([function (t, n, e) {
      var r = e(21)("wks"),
          o = e(13),
          i = e(2).Symbol,
          u = "function" == typeof i;
      (t.exports = function (t) {
        return r[t] || (r[t] = u && i[t] || (u ? i : o)("Symbol." + t));
      }).store = r;
    }, function (t, n, e) {
      var r = e(2),
          o = e(12),
          i = e(3),
          u = e(15),
          c = e(39),
          a = function a(t, n, e) {
        var s,
            f,
            l,
            p,
            h = t & a.F,
            v = t & a.G,
            y = t & a.S,
            g = t & a.P,
            d = t & a.B,
            m = v ? r : y ? r[n] || (r[n] = {}) : (r[n] || {}).prototype,
            b = v ? o : o[n] || (o[n] = {}),
            x = b.prototype || (b.prototype = {});

        for (s in v && (e = n), e) {
          l = ((f = !h && m && void 0 !== m[s]) ? m : e)[s], p = d && f ? c(l, r) : g && "function" == typeof l ? c(Function.call, l) : l, m && u(m, s, l, t & a.U), b[s] != l && i(b, s, p), g && x[s] != l && (x[s] = l);
        }
      };

      r.core = o, a.F = 1, a.G = 2, a.S = 4, a.P = 8, a.B = 16, a.W = 32, a.U = 64, a.R = 128, t.exports = a;
    }, function (t, n) {
      var e = t.exports = "undefined" != typeof window && window.Math == Math ? window : "undefined" != typeof self && self.Math == Math ? self : Function("return this")();
      "number" == typeof __g && (__g = e);
    }, function (t, n, e) {
      var r = e(7),
          o = e(18);
      t.exports = e(8) ? function (t, n, e) {
        return r.f(t, n, o(1, e));
      } : function (t, n, e) {
        return t[n] = e, t;
      };
    }, function (t, n) {
      t.exports = function (t) {
        try {
          return !!t();
        } catch (t) {
          return !0;
        }
      };
    }, function (t, n) {
      t.exports = function (t) {
        return "object" == typeof t ? null !== t : "function" == typeof t;
      };
    }, function (t, n, e) {
      var r = e(5);

      t.exports = function (t) {
        if (!r(t)) throw TypeError(t + " is not an object!");
        return t;
      };
    }, function (t, n, e) {
      var r = e(6),
          o = e(37),
          i = e(25),
          u = Object.defineProperty;
      n.f = e(8) ? Object.defineProperty : function (t, n, e) {
        if (r(t), n = i(n, !0), r(e), o) try {
          return u(t, n, e);
        } catch (t) {}
        if ("get" in e || "set" in e) throw TypeError("Accessors not supported!");
        return "value" in e && (t[n] = e.value), t;
      };
    }, function (t, n, e) {
      t.exports = !e(4)(function () {
        return 7 != Object.defineProperty({}, "a", {
          get: function get() {
            return 7;
          }
        }).a;
      });
    }, function (t, n) {
      var e = {}.hasOwnProperty;

      t.exports = function (t, n) {
        return e.call(t, n);
      };
    }, function (t, n, e) {
      var r = e(41),
          o = e(28);

      t.exports = Object.keys || function (t) {
        return r(t, o);
      };
    }, function (t, n, e) {
      var r = e(26),
          o = e(14);

      t.exports = function (t) {
        return r(o(t));
      };
    }, function (t, n) {
      var e = t.exports = {
        version: "2.6.0"
      };
      "number" == typeof __e && (__e = e);
    }, function (t, n) {
      var e = 0,
          r = Math.random();

      t.exports = function (t) {
        return "Symbol(".concat(void 0 === t ? "" : t, ")_", (++e + r).toString(36));
      };
    }, function (t, n) {
      t.exports = function (t) {
        if (null == t) throw TypeError("Can't call method on  " + t);
        return t;
      };
    }, function (t, n, e) {
      var r = e(2),
          o = e(3),
          i = e(9),
          u = e(13)("src"),
          c = Function.toString,
          a = ("" + c).split("toString");
      e(12).inspectSource = function (t) {
        return c.call(t);
      }, (t.exports = function (t, n, e, c) {
        var s = "function" == typeof e;
        s && (i(e, "name") || o(e, "name", n)), t[n] !== e && (s && (i(e, u) || o(e, u, t[n] ? "" + t[n] : a.join(String(n)))), t === r ? t[n] = e : c ? t[n] ? t[n] = e : o(t, n, e) : (delete t[n], o(t, n, e)));
      })(Function.prototype, "toString", function () {
        return "function" == typeof this && this[u] || c.call(this);
      });
    }, function (t, n) {
      var e = {}.toString;

      t.exports = function (t) {
        return e.call(t).slice(8, -1);
      };
    }, function (t, n) {
      t.exports = !1;
    }, function (t, n) {
      t.exports = function (t, n) {
        return {
          enumerable: !(1 & t),
          configurable: !(2 & t),
          writable: !(4 & t),
          value: n
        };
      };
    }, function (t, n) {
      n.f = {}.propertyIsEnumerable;
    }, function (t, n, e) {
      var r = e(14);

      t.exports = function (t) {
        return Object(r(t));
      };
    }, function (t, n, e) {
      var r = e(12),
          o = e(2),
          i = o["__core-js_shared__"] || (o["__core-js_shared__"] = {});
      (t.exports = function (t, n) {
        return i[t] || (i[t] = void 0 !== n ? n : {});
      })("versions", []).push({
        version: r.version,
        mode: e(17) ? "pure" : "global",
        copyright: "© 2018 Denis Pushkarev (zloirock.ru)"
      });
    }, function (t, n) {
      var e = Math.ceil,
          r = Math.floor;

      t.exports = function (t) {
        return isNaN(t = +t) ? 0 : (t > 0 ? r : e)(t);
      };
    }, function (t, n, e) {
      var r = e(22),
          o = Math.min;

      t.exports = function (t) {
        return t > 0 ? o(r(t), 9007199254740991) : 0;
      };
    }, function (t, n, e) {
      "use strict";

      var r,
          o,
          i = e(58),
          u = RegExp.prototype.exec,
          c = String.prototype.replace,
          a = u,
          s = (r = /a/, o = /b*/g, u.call(r, "a"), u.call(o, "a"), 0 !== r.lastIndex || 0 !== o.lastIndex),
          f = void 0 !== /()??/.exec("")[1];
      (s || f) && (a = function a(t) {
        var n,
            e,
            r,
            o,
            a = this;
        return f && (e = new RegExp("^" + a.source + "$(?!\\s)", i.call(a))), s && (n = a.lastIndex), r = u.call(a, t), s && r && (a.lastIndex = a.global ? r.index + r[0].length : n), f && r && r.length > 1 && c.call(r[0], e, function () {
          for (o = 1; o < arguments.length - 2; o++) {
            void 0 === arguments[o] && (r[o] = void 0);
          }
        }), r;
      }), t.exports = a;
    }, function (t, n, e) {
      var r = e(5);

      t.exports = function (t, n) {
        if (!r(t)) return t;
        var e, o;
        if (n && "function" == typeof (e = t.toString) && !r(o = e.call(t))) return o;
        if ("function" == typeof (e = t.valueOf) && !r(o = e.call(t))) return o;
        if (!n && "function" == typeof (e = t.toString) && !r(o = e.call(t))) return o;
        throw TypeError("Can't convert object to primitive value");
      };
    }, function (t, n, e) {
      var r = e(16);
      t.exports = Object("z").propertyIsEnumerable(0) ? Object : function (t) {
        return "String" == r(t) ? t.split("") : Object(t);
      };
    }, function (t, n, e) {
      var r = e(21)("keys"),
          o = e(13);

      t.exports = function (t) {
        return r[t] || (r[t] = o(t));
      };
    }, function (t, n) {
      t.exports = "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",");
    }, function (t, n) {
      n.f = Object.getOwnPropertySymbols;
    }, function (t, n, e) {
      "use strict";

      var r = e(43),
          o = e(63),
          i = e(31),
          u = e(11);
      t.exports = e(64)(Array, "Array", function (t, n) {
        this._t = u(t), this._i = 0, this._k = n;
      }, function () {
        var t = this._t,
            n = this._k,
            e = this._i++;
        return !t || e >= t.length ? (this._t = void 0, o(1)) : o(0, "keys" == n ? e : "values" == n ? t[e] : [e, t[e]]);
      }, "values"), i.Arguments = i.Array, r("keys"), r("values"), r("entries");
    }, function (t, n) {
      t.exports = {};
    }, function (t, n, e) {
      var r = e(7).f,
          o = e(9),
          i = e(0)("toStringTag");

      t.exports = function (t, n, e) {
        t && !o(t = e ? t : t.prototype, i) && r(t, i, {
          configurable: !0,
          value: n
        });
      };
    }, function (t, n, e) {
      var r = e(16);

      t.exports = Array.isArray || function (t) {
        return "Array" == r(t);
      };
    }, function (t, n, e) {
      "use strict";

      var r = e(35),
          o = e(6),
          i = e(53),
          u = e(54),
          c = e(23),
          a = e(56),
          s = e(24),
          f = Math.min,
          l = [].push,
          p = !!function () {
        try {
          return new RegExp("x", "y");
        } catch (t) {}
      }();
      e(59)("split", 2, function (t, n, e, h) {
        var v = e;
        return "c" == "abbc".split(/(b)*/)[1] || 4 != "test".split(/(?:)/, -1).length || 2 != "ab".split(/(?:ab)*/).length || 4 != ".".split(/(.?)(.?)/).length || ".".split(/()()/).length > 1 || "".split(/.?/).length ? v = function v(t, n) {
          var o = String(this);
          if (void 0 === t && 0 === n) return [];
          if (!r(t)) return e.call(o, t, n);

          for (var i, u, c, a = [], f = (t.ignoreCase ? "i" : "") + (t.multiline ? "m" : "") + (t.unicode ? "u" : "") + (t.sticky ? "y" : ""), p = 0, h = void 0 === n ? 4294967295 : n >>> 0, v = new RegExp(t.source, f + "g"); (i = s.call(v, o)) && !((u = v.lastIndex) > p && (a.push(o.slice(p, i.index)), i.length > 1 && i.index < o.length && l.apply(a, i.slice(1)), c = i[0].length, p = u, a.length >= h));) {
            v.lastIndex === i.index && v.lastIndex++;
          }

          return p === o.length ? !c && v.test("") || a.push("") : a.push(o.slice(p)), a.length > h ? a.slice(0, h) : a;
        } : "0".split(void 0, 0).length && (v = function v(t, n) {
          return void 0 === t && 0 === n ? [] : e.call(this, t, n);
        }), [function (e, r) {
          var o = t(this),
              i = null == e ? void 0 : e[n];
          return void 0 !== i ? i.call(e, o, r) : v.call(String(o), e, r);
        }, function (t, n) {
          var r = h(v, t, this, n, v !== e);
          if (r.done) return r.value;
          var s = o(t),
              l = String(this),
              y = i(s, RegExp),
              g = s.unicode,
              d = (s.ignoreCase ? "i" : "") + (s.multiline ? "m" : "") + (s.unicode ? "u" : "") + (p ? "y" : "g"),
              m = new y(p ? s : "^(?:" + s.source + ")", d),
              b = void 0 === n ? 4294967295 : n >>> 0;
          if (0 === b) return [];
          if (0 === l.length) return null === a(m, l) ? [l] : [];

          for (var x = 0, w = 0, O = []; w < l.length;) {
            m.lastIndex = p ? w : 0;
            var j,
                E = a(m, p ? l : l.slice(w));
            if (null === E || (j = f(c(m.lastIndex + (p ? 0 : w)), l.length)) === x) w = u(l, w, g);else {
              if (O.push(l.slice(x, w)), O.length === b) return O;

              for (var S = 1; S <= E.length - 1; S++) {
                if (O.push(E[S]), O.length === b) return O;
              }

              w = x = j;
            }
          }

          return O.push(l.slice(x)), O;
        }];
      });
    }, function (t, n, e) {
      var r = e(5),
          o = e(16),
          i = e(0)("match");

      t.exports = function (t) {
        var n;
        return r(t) && (void 0 !== (n = t[i]) ? !!n : "RegExp" == o(t));
      };
    }, function (t, n) {
      t.exports = function (t) {
        if ("function" != typeof t) throw TypeError(t + " is not a function!");
        return t;
      };
    }, function (t, n, e) {
      t.exports = !e(8) && !e(4)(function () {
        return 7 != Object.defineProperty(e(38)("div"), "a", {
          get: function get() {
            return 7;
          }
        }).a;
      });
    }, function (t, n, e) {
      var r = e(5),
          o = e(2).document,
          i = r(o) && r(o.createElement);

      t.exports = function (t) {
        return i ? o.createElement(t) : {};
      };
    }, function (t, n, e) {
      var r = e(36);

      t.exports = function (t, n, e) {
        if (r(t), void 0 === n) return t;

        switch (e) {
          case 1:
            return function (e) {
              return t.call(n, e);
            };

          case 2:
            return function (e, r) {
              return t.call(n, e, r);
            };

          case 3:
            return function (e, r, o) {
              return t.call(n, e, r, o);
            };
        }

        return function () {
          return t.apply(n, arguments);
        };
      };
    }, function (t, n, e) {
      var r = e(1);
      r(r.S + r.F, "Object", {
        assign: e(61)
      });
    }, function (t, n, e) {
      var r = e(9),
          o = e(11),
          i = e(42)(!1),
          u = e(27)("IE_PROTO");

      t.exports = function (t, n) {
        var e,
            c = o(t),
            a = 0,
            s = [];

        for (e in c) {
          e != u && r(c, e) && s.push(e);
        }

        for (; n.length > a;) {
          r(c, e = n[a++]) && (~i(s, e) || s.push(e));
        }

        return s;
      };
    }, function (t, n, e) {
      var r = e(11),
          o = e(23),
          i = e(62);

      t.exports = function (t) {
        return function (n, e, u) {
          var c,
              a = r(n),
              s = o(a.length),
              f = i(u, s);

          if (t && e != e) {
            for (; s > f;) {
              if ((c = a[f++]) != c) return !0;
            }
          } else for (; s > f; f++) {
            if ((t || f in a) && a[f] === e) return t || f || 0;
          }

          return !t && -1;
        };
      };
    }, function (t, n, e) {
      var r = e(0)("unscopables"),
          o = Array.prototype;
      null == o[r] && e(3)(o, r, {}), t.exports = function (t) {
        o[r][t] = !0;
      };
    }, function (t, n, e) {
      var r = e(6),
          o = e(66),
          i = e(28),
          u = e(27)("IE_PROTO"),
          c = function c() {},
          _a = function a() {
        var t,
            n = e(38)("iframe"),
            r = i.length;

        for (n.style.display = "none", e(67).appendChild(n), n.src = "javascript:", (t = n.contentWindow.document).open(), t.write("<script>document.F=Object<\/script>"), t.close(), _a = t.F; r--;) {
          delete _a.prototype[i[r]];
        }

        return _a();
      };

      t.exports = Object.create || function (t, n) {
        var e;
        return null !== t ? (c.prototype = r(t), e = new c(), c.prototype = null, e[u] = t) : e = _a(), void 0 === n ? e : o(e, n);
      };
    }, function (t, n, e) {
      var r = e(20),
          o = e(10);
      e(69)("keys", function () {
        return function (t) {
          return o(r(t));
        };
      });
    }, function (t, n, e) {
      for (var r = e(30), o = e(10), i = e(15), u = e(2), c = e(3), a = e(31), s = e(0), f = s("iterator"), l = s("toStringTag"), p = a.Array, h = {
        CSSRuleList: !0,
        CSSStyleDeclaration: !1,
        CSSValueList: !1,
        ClientRectList: !1,
        DOMRectList: !1,
        DOMStringList: !1,
        DOMTokenList: !0,
        DataTransferItemList: !1,
        FileList: !1,
        HTMLAllCollection: !1,
        HTMLCollection: !1,
        HTMLFormElement: !1,
        HTMLSelectElement: !1,
        MediaList: !0,
        MimeTypeArray: !1,
        NamedNodeMap: !1,
        NodeList: !0,
        PaintRequestList: !1,
        Plugin: !1,
        PluginArray: !1,
        SVGLengthList: !1,
        SVGNumberList: !1,
        SVGPathSegList: !1,
        SVGPointList: !1,
        SVGStringList: !1,
        SVGTransformList: !1,
        SourceBufferList: !1,
        StyleSheetList: !0,
        TextTrackCueList: !1,
        TextTrackList: !1,
        TouchList: !1
      }, v = o(h), y = 0; y < v.length; y++) {
        var g,
            d = v[y],
            m = h[d],
            b = u[d],
            x = b && b.prototype;
        if (x && (x[f] || c(x, f, p), x[l] || c(x, l, d), a[d] = p, m)) for (g in r) {
          x[g] || i(x, g, r[g], !0);
        }
      }
    }, function (t, n, e) {
      "use strict";

      var r = e(1),
          o = e(48)(0),
          i = e(49)([].forEach, !0);
      r(r.P + r.F * !i, "Array", {
        forEach: function forEach(t) {
          return o(this, t, arguments[1]);
        }
      });
    }, function (t, n, e) {
      var r = e(39),
          o = e(26),
          i = e(20),
          u = e(23),
          c = e(70);

      t.exports = function (t, n) {
        var e = 1 == t,
            a = 2 == t,
            s = 3 == t,
            f = 4 == t,
            l = 6 == t,
            p = 5 == t || l,
            h = n || c;
        return function (n, c, v) {
          for (var y, g, d = i(n), m = o(d), b = r(c, v, 3), x = u(m.length), w = 0, O = e ? h(n, x) : a ? h(n, 0) : void 0; x > w; w++) {
            if ((p || w in m) && (g = b(y = m[w], w, d), t)) if (e) O[w] = g;else if (g) switch (t) {
              case 3:
                return !0;

              case 5:
                return y;

              case 6:
                return w;

              case 2:
                O.push(y);
            } else if (f) return !1;
          }

          return l ? -1 : s || f ? f : O;
        };
      };
    }, function (t, n, e) {
      "use strict";

      var r = e(4);

      t.exports = function (t, n) {
        return !!t && r(function () {
          n ? t.call(null, function () {}, 1) : t.call(null);
        });
      };
    }, function (t, n, e) {
      var r = e(2),
          o = e(12),
          i = e(17),
          u = e(51),
          c = e(7).f;

      t.exports = function (t) {
        var n = o.Symbol || (o.Symbol = i ? {} : r.Symbol || {});
        "_" == t.charAt(0) || t in n || c(n, t, {
          value: u.f(t)
        });
      };
    }, function (t, n, e) {
      n.f = e(0);
    }, function (t, n, e) {
      var r = e(41),
          o = e(28).concat("length", "prototype");

      n.f = Object.getOwnPropertyNames || function (t) {
        return r(t, o);
      };
    }, function (t, n, e) {
      var r = e(6),
          o = e(36),
          i = e(0)("species");

      t.exports = function (t, n) {
        var e,
            u = r(t).constructor;
        return void 0 === u || null == (e = r(u)[i]) ? n : o(e);
      };
    }, function (t, n, e) {
      "use strict";

      var r = e(55)(!0);

      t.exports = function (t, n, e) {
        return n + (e ? r(t, n).length : 1);
      };
    }, function (t, n, e) {
      var r = e(22),
          o = e(14);

      t.exports = function (t) {
        return function (n, e) {
          var i,
              u,
              c = String(o(n)),
              a = r(e),
              s = c.length;
          return a < 0 || a >= s ? t ? "" : void 0 : (i = c.charCodeAt(a)) < 55296 || i > 56319 || a + 1 === s || (u = c.charCodeAt(a + 1)) < 56320 || u > 57343 ? t ? c.charAt(a) : i : t ? c.slice(a, a + 2) : u - 56320 + (i - 55296 << 10) + 65536;
        };
      };
    }, function (t, n, e) {
      "use strict";

      var r = e(57),
          o = RegExp.prototype.exec;

      t.exports = function (t, n) {
        var e = t.exec;

        if ("function" == typeof e) {
          var i = e.call(t, n);
          if ("object" != typeof i) throw new TypeError("RegExp exec method returned something other than an Object or null");
          return i;
        }

        if ("RegExp" !== r(t)) throw new TypeError("RegExp#exec called on incompatible receiver");
        return o.call(t, n);
      };
    }, function (t, n, e) {
      var r = e(16),
          o = e(0)("toStringTag"),
          i = "Arguments" == r(function () {
        return arguments;
      }());

      t.exports = function (t) {
        var n, e, u;
        return void 0 === t ? "Undefined" : null === t ? "Null" : "string" == typeof (e = function (t, n) {
          try {
            return t[n];
          } catch (t) {}
        }(n = Object(t), o)) ? e : i ? r(n) : "Object" == (u = r(n)) && "function" == typeof n.callee ? "Arguments" : u;
      };
    }, function (t, n, e) {
      "use strict";

      var r = e(6);

      t.exports = function () {
        var t = r(this),
            n = "";
        return t.global && (n += "g"), t.ignoreCase && (n += "i"), t.multiline && (n += "m"), t.unicode && (n += "u"), t.sticky && (n += "y"), n;
      };
    }, function (t, n, e) {
      "use strict";

      e(60);

      var r = e(15),
          o = e(3),
          i = e(4),
          u = e(14),
          c = e(0),
          a = e(24),
          s = c("species"),
          f = !i(function () {
        var t = /./;
        return t.exec = function () {
          var t = [];
          return t.groups = {
            a: "7"
          }, t;
        }, "7" !== "".replace(t, "$<a>");
      }),
          l = function () {
        var t = /(?:)/,
            n = t.exec;

        t.exec = function () {
          return n.apply(this, arguments);
        };

        var e = "ab".split(t);
        return 2 === e.length && "a" === e[0] && "b" === e[1];
      }();

      t.exports = function (t, n, e) {
        var p = c(t),
            h = !i(function () {
          var n = {};
          return n[p] = function () {
            return 7;
          }, 7 != ""[t](n);
        }),
            v = h ? !i(function () {
          var n = !1,
              e = /a/;
          return e.exec = function () {
            return n = !0, null;
          }, "split" === t && (e.constructor = {}, e.constructor[s] = function () {
            return e;
          }), e[p](""), !n;
        }) : void 0;

        if (!h || !v || "replace" === t && !f || "split" === t && !l) {
          var y = /./[p],
              g = e(u, p, ""[t], function (t, n, e, r, o) {
            return n.exec === a ? h && !o ? {
              done: !0,
              value: y.call(n, e, r)
            } : {
              done: !0,
              value: t.call(e, n, r)
            } : {
              done: !1
            };
          }),
              d = g[0],
              m = g[1];
          r(String.prototype, t, d), o(RegExp.prototype, p, 2 == n ? function (t, n) {
            return m.call(t, this, n);
          } : function (t) {
            return m.call(t, this);
          });
        }
      };
    }, function (t, n, e) {
      "use strict";

      var r = e(24);
      e(1)({
        target: "RegExp",
        proto: !0,
        forced: r !== /./.exec
      }, {
        exec: r
      });
    }, function (t, n, e) {
      "use strict";

      var r = e(10),
          o = e(29),
          i = e(19),
          u = e(20),
          c = e(26),
          a = Object.assign;
      t.exports = !a || e(4)(function () {
        var t = {},
            n = {},
            e = Symbol(),
            r = "abcdefghijklmnopqrst";
        return t[e] = 7, r.split("").forEach(function (t) {
          n[t] = t;
        }), 7 != a({}, t)[e] || Object.keys(a({}, n)).join("") != r;
      }) ? function (t, n) {
        for (var e = u(t), a = arguments.length, s = 1, f = o.f, l = i.f; a > s;) {
          for (var p, h = c(arguments[s++]), v = f ? r(h).concat(f(h)) : r(h), y = v.length, g = 0; y > g;) {
            l.call(h, p = v[g++]) && (e[p] = h[p]);
          }
        }

        return e;
      } : a;
    }, function (t, n, e) {
      var r = e(22),
          o = Math.max,
          i = Math.min;

      t.exports = function (t, n) {
        return (t = r(t)) < 0 ? o(t + n, 0) : i(t, n);
      };
    }, function (t, n) {
      t.exports = function (t, n) {
        return {
          value: n,
          done: !!t
        };
      };
    }, function (t, n, e) {
      "use strict";

      var r = e(17),
          o = e(1),
          i = e(15),
          u = e(3),
          c = e(31),
          a = e(65),
          s = e(32),
          f = e(68),
          l = e(0)("iterator"),
          p = !([].keys && "next" in [].keys()),
          h = function h() {
        return this;
      };

      t.exports = function (t, n, e, v, y, g, d) {
        a(e, n, v);

        var m,
            b,
            x,
            w = function w(t) {
          if (!p && t in S) return S[t];

          switch (t) {
            case "keys":
            case "values":
              return function () {
                return new e(this, t);
              };
          }

          return function () {
            return new e(this, t);
          };
        },
            O = n + " Iterator",
            j = "values" == y,
            E = !1,
            S = t.prototype,
            _ = S[l] || S["@@iterator"] || y && S[y],
            k = _ || w(y),
            P = y ? j ? w("entries") : k : void 0,
            L = "Array" == n && S.entries || _;

        if (L && (x = f(L.call(new t()))) !== Object.prototype && x.next && (s(x, O, !0), r || "function" == typeof x[l] || u(x, l, h)), j && _ && "values" !== _.name && (E = !0, k = function k() {
          return _.call(this);
        }), r && !d || !p && !E && S[l] || u(S, l, k), c[n] = k, c[O] = h, y) if (m = {
          values: j ? k : w("values"),
          keys: g ? k : w("keys"),
          entries: P
        }, d) for (b in m) {
          b in S || i(S, b, m[b]);
        } else o(o.P + o.F * (p || E), n, m);
        return m;
      };
    }, function (t, n, e) {
      "use strict";

      var r = e(44),
          o = e(18),
          i = e(32),
          u = {};
      e(3)(u, e(0)("iterator"), function () {
        return this;
      }), t.exports = function (t, n, e) {
        t.prototype = r(u, {
          next: o(1, e)
        }), i(t, n + " Iterator");
      };
    }, function (t, n, e) {
      var r = e(7),
          o = e(6),
          i = e(10);
      t.exports = e(8) ? Object.defineProperties : function (t, n) {
        o(t);

        for (var e, u = i(n), c = u.length, a = 0; c > a;) {
          r.f(t, e = u[a++], n[e]);
        }

        return t;
      };
    }, function (t, n, e) {
      var r = e(2).document;
      t.exports = r && r.documentElement;
    }, function (t, n, e) {
      var r = e(9),
          o = e(20),
          i = e(27)("IE_PROTO"),
          u = Object.prototype;

      t.exports = Object.getPrototypeOf || function (t) {
        return t = o(t), r(t, i) ? t[i] : "function" == typeof t.constructor && t instanceof t.constructor ? t.constructor.prototype : t instanceof Object ? u : null;
      };
    }, function (t, n, e) {
      var r = e(1),
          o = e(12),
          i = e(4);

      t.exports = function (t, n) {
        var e = (o.Object || {})[t] || Object[t],
            u = {};
        u[t] = n(e), r(r.S + r.F * i(function () {
          e(1);
        }), "Object", u);
      };
    }, function (t, n, e) {
      var r = e(71);

      t.exports = function (t, n) {
        return new (r(t))(n);
      };
    }, function (t, n, e) {
      var r = e(5),
          o = e(33),
          i = e(0)("species");

      t.exports = function (t) {
        var n;
        return o(t) && ("function" != typeof (n = t.constructor) || n !== Array && !o(n.prototype) || (n = void 0), r(n) && null === (n = n[i]) && (n = void 0)), void 0 === n ? Array : n;
      };
    }, function (t, n, e) {
      e(50)("asyncIterator");
    }, function (t, n, e) {
      "use strict";

      var r = e(2),
          o = e(9),
          i = e(8),
          u = e(1),
          c = e(15),
          a = e(74).KEY,
          s = e(4),
          f = e(21),
          l = e(32),
          p = e(13),
          h = e(0),
          v = e(51),
          y = e(50),
          g = e(75),
          d = e(33),
          m = e(6),
          b = e(5),
          x = e(11),
          w = e(25),
          O = e(18),
          j = e(44),
          E = e(76),
          S = e(77),
          _ = e(7),
          k = e(10),
          P = S.f,
          L = _.f,
          A = E.f,
          _T = r.Symbol,
          M = r.JSON,
          F = M && M.stringify,
          N = h("_hidden"),
          I = h("toPrimitive"),
          R = {}.propertyIsEnumerable,
          C = f("symbol-registry"),
          G = f("symbols"),
          D = f("op-symbols"),
          V = Object.prototype,
          q = "function" == typeof _T,
          K = r.QObject,
          W = !K || !K.prototype || !K.prototype.findChild,
          H = i && s(function () {
        return 7 != j(L({}, "a", {
          get: function get() {
            return L(this, "a", {
              value: 7
            }).a;
          }
        })).a;
      }) ? function (t, n, e) {
        var r = P(V, n);
        r && delete V[n], L(t, n, e), r && t !== V && L(V, n, r);
      } : L,
          J = function J(t) {
        var n = G[t] = j(_T.prototype);
        return n._k = t, n;
      },
          Y = q && "symbol" == typeof _T.iterator ? function (t) {
        return "symbol" == typeof t;
      } : function (t) {
        return t instanceof _T;
      },
          z = function z(t, n, e) {
        return t === V && z(D, n, e), m(t), n = w(n, !0), m(e), o(G, n) ? (e.enumerable ? (o(t, N) && t[N][n] && (t[N][n] = !1), e = j(e, {
          enumerable: O(0, !1)
        })) : (o(t, N) || L(t, N, O(1, {})), t[N][n] = !0), H(t, n, e)) : L(t, n, e);
      },
          B = function B(t, n) {
        m(t);

        for (var e, r = g(n = x(n)), o = 0, i = r.length; i > o;) {
          z(t, e = r[o++], n[e]);
        }

        return t;
      },
          Q = function Q(t) {
        var n = R.call(this, t = w(t, !0));
        return !(this === V && o(G, t) && !o(D, t)) && (!(n || !o(this, t) || !o(G, t) || o(this, N) && this[N][t]) || n);
      },
          U = function U(t, n) {
        if (t = x(t), n = w(n, !0), t !== V || !o(G, n) || o(D, n)) {
          var e = P(t, n);
          return !e || !o(G, n) || o(t, N) && t[N][n] || (e.enumerable = !0), e;
        }
      },
          X = function X(t) {
        for (var n, e = A(x(t)), r = [], i = 0; e.length > i;) {
          o(G, n = e[i++]) || n == N || n == a || r.push(n);
        }

        return r;
      },
          $ = function $(t) {
        for (var n, e = t === V, r = A(e ? D : x(t)), i = [], u = 0; r.length > u;) {
          !o(G, n = r[u++]) || e && !o(V, n) || i.push(G[n]);
        }

        return i;
      };

      q || (c((_T = function T() {
        if (this instanceof _T) throw TypeError("Symbol is not a constructor!");

        var t = p(arguments.length > 0 ? arguments[0] : void 0),
            n = function n(e) {
          this === V && n.call(D, e), o(this, N) && o(this[N], t) && (this[N][t] = !1), H(this, t, O(1, e));
        };

        return i && W && H(V, t, {
          configurable: !0,
          set: n
        }), J(t);
      }).prototype, "toString", function () {
        return this._k;
      }), S.f = U, _.f = z, e(52).f = E.f = X, e(19).f = Q, e(29).f = $, i && !e(17) && c(V, "propertyIsEnumerable", Q, !0), v.f = function (t) {
        return J(h(t));
      }), u(u.G + u.W + u.F * !q, {
        Symbol: _T
      });

      for (var Z = "hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(","), tt = 0; Z.length > tt;) {
        h(Z[tt++]);
      }

      for (var nt = k(h.store), et = 0; nt.length > et;) {
        y(nt[et++]);
      }

      u(u.S + u.F * !q, "Symbol", {
        for: function _for(t) {
          return o(C, t += "") ? C[t] : C[t] = _T(t);
        },
        keyFor: function keyFor(t) {
          if (!Y(t)) throw TypeError(t + " is not a symbol!");

          for (var n in C) {
            if (C[n] === t) return n;
          }
        },
        useSetter: function useSetter() {
          W = !0;
        },
        useSimple: function useSimple() {
          W = !1;
        }
      }), u(u.S + u.F * !q, "Object", {
        create: function create(t, n) {
          return void 0 === n ? j(t) : B(j(t), n);
        },
        defineProperty: z,
        defineProperties: B,
        getOwnPropertyDescriptor: U,
        getOwnPropertyNames: X,
        getOwnPropertySymbols: $
      }), M && u(u.S + u.F * (!q || s(function () {
        var t = _T();

        return "[null]" != F([t]) || "{}" != F({
          a: t
        }) || "{}" != F(Object(t));
      })), "JSON", {
        stringify: function stringify(t) {
          for (var n, e, r = [t], o = 1; arguments.length > o;) {
            r.push(arguments[o++]);
          }

          if (e = n = r[1], (b(n) || void 0 !== t) && !Y(t)) return d(n) || (n = function n(t, _n) {
            if ("function" == typeof e && (_n = e.call(this, t, _n)), !Y(_n)) return _n;
          }), r[1] = n, F.apply(M, r);
        }
      }), _T.prototype[I] || e(3)(_T.prototype, I, _T.prototype.valueOf), l(_T, "Symbol"), l(Math, "Math", !0), l(r.JSON, "JSON", !0);
    }, function (t, n, e) {
      var r = e(13)("meta"),
          o = e(5),
          i = e(9),
          u = e(7).f,
          c = 0,
          a = Object.isExtensible || function () {
        return !0;
      },
          s = !e(4)(function () {
        return a(Object.preventExtensions({}));
      }),
          f = function f(t) {
        u(t, r, {
          value: {
            i: "O" + ++c,
            w: {}
          }
        });
      },
          l = t.exports = {
        KEY: r,
        NEED: !1,
        fastKey: function fastKey(t, n) {
          if (!o(t)) return "symbol" == typeof t ? t : ("string" == typeof t ? "S" : "P") + t;

          if (!i(t, r)) {
            if (!a(t)) return "F";
            if (!n) return "E";
            f(t);
          }

          return t[r].i;
        },
        getWeak: function getWeak(t, n) {
          if (!i(t, r)) {
            if (!a(t)) return !0;
            if (!n) return !1;
            f(t);
          }

          return t[r].w;
        },
        onFreeze: function onFreeze(t) {
          return s && l.NEED && a(t) && !i(t, r) && f(t), t;
        }
      };
    }, function (t, n, e) {
      var r = e(10),
          o = e(29),
          i = e(19);

      t.exports = function (t) {
        var n = r(t),
            e = o.f;
        if (e) for (var u, c = e(t), a = i.f, s = 0; c.length > s;) {
          a.call(t, u = c[s++]) && n.push(u);
        }
        return n;
      };
    }, function (t, n, e) {
      var r = e(11),
          o = e(52).f,
          i = {}.toString,
          u = "object" == typeof window && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];

      t.exports.f = function (t) {
        return u && "[object Window]" == i.call(t) ? function (t) {
          try {
            return o(t);
          } catch (t) {
            return u.slice();
          }
        }(t) : o(r(t));
      };
    }, function (t, n, e) {
      var r = e(19),
          o = e(18),
          i = e(11),
          u = e(25),
          c = e(9),
          a = e(37),
          s = Object.getOwnPropertyDescriptor;
      n.f = e(8) ? s : function (t, n) {
        if (t = i(t), n = u(n, !0), a) try {
          return s(t, n);
        } catch (t) {}
        if (c(t, n)) return o(!r.f.call(t, n), t[n]);
      };
    }, function (t, n, e) {
      "use strict";

      var r = e(1),
          o = e(48)(2);
      r(r.P + r.F * !e(49)([].filter, !0), "Array", {
        filter: function filter(t) {
          return o(this, t, arguments[1]);
        }
      });
    }, function (t, n, e) {
      var r = e(1);
      r(r.S + r.F * !e(8), "Object", {
        defineProperty: e(7).f
      });
    }, function (t, n, e) {
      "use strict";

      var r = e(1),
          o = e(42)(!0);
      r(r.P, "Array", {
        includes: function includes(t) {
          return o(this, t, arguments.length > 1 ? arguments[1] : void 0);
        }
      }), e(43)("includes");
    }, function (t, n, e) {
      "use strict";

      var r = e(1),
          o = e(82);
      r(r.P + r.F * e(83)("includes"), "String", {
        includes: function includes(t) {
          return !!~o(this, t, "includes").indexOf(t, arguments.length > 1 ? arguments[1] : void 0);
        }
      });
    }, function (t, n, e) {
      var r = e(35),
          o = e(14);

      t.exports = function (t, n, e) {
        if (r(n)) throw TypeError("String#" + e + " doesn't accept regex!");
        return String(o(t));
      };
    }, function (t, n, e) {
      var r = e(0)("match");

      t.exports = function (t) {
        var n = /./;

        try {
          "/./"[t](n);
        } catch (e) {
          try {
            return n[r] = !1, !"/./"[t](n);
          } catch (t) {}
        }

        return !0;
      };
    }, function (t, n, e) {
      var r = e(1);
      r(r.S, "Array", {
        isArray: e(33)
      });
    }, function (t, n, e) {
      "use strict";

      function r(t) {
        return (r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
          return typeof t;
        } : function (t) {
          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        })(t);
      }

      function o(t, n, e) {
        return n in t ? Object.defineProperty(t, n, {
          value: e,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : t[n] = e, t;
      }

      function i(t, n) {
        for (var e = 0; e < n.length; e++) {
          var r = n[e];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
        }
      }

      e.r(n), e(34), e(40), e(30), e(45), e(46), e(47), e(72), e(73), e(78), e(79), e(80), e(81), e(84);

      var u = function () {
        function t() {
          !function (t, n) {
            if (!(t instanceof n)) throw new TypeError("Cannot call a class as a function");
          }(this, t);
        }

        var n, e;
        return n = t, (e = [{
          key: "isLeaf",
          value: function value(t) {
            return 0 === (t.remaining || "").length;
          }
        }, {
          key: "merge",
          value: function value(n, e) {
            var i = function (t) {
              for (var n = 1; n < arguments.length; n++) {
                var e = null != arguments[n] ? arguments[n] : {},
                    r = Object.keys(e);
                "function" == typeof Object.getOwnPropertySymbols && (r = r.concat(Object.getOwnPropertySymbols(e).filter(function (t) {
                  return Object.getOwnPropertyDescriptor(e, t).enumerable;
                }))), r.forEach(function (n) {
                  o(t, n, e[n]);
                });
              }

              return t;
            }({}, n);

            return Object.keys(e).forEach(function (o) {
              null === e[o] || "object" !== r(e[o]) || Array.isArray(e[o]) ? i[o] = e[o] : i[o] = Object.assign(new e[o].constructor(), t.merge(n[o] || {}, e[o]));
            }), i;
          }
        }, {
          key: "make",
          value: function value(t) {
            for (var n, e, r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}, i = arguments.length > 3 ? arguments[3] : void 0, u = t.split("."), c = o, a = null; u.length;) {
              (n = a || c)[e = u.shift()] = i ? i(e, n[e] || {}, a) : n[e] || {}, a = n[e];
            }

            return n[e] = Object.assign(n[e], r), c;
          }
        }, {
          key: "traverseKey",
          value: function value(n, e, o, i, u) {
            var c = e,
                a = c[n];
            o.includes(a) || null !== a && "object" === r(a) && Object.keys(a).length > 0 && (a = i(n, a, u) || c[n], o.push(a), c[n] = t._traverse(a, a, o, i));
          }
        }, {
          key: "_traverse",
          value: function value(n) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null,
                r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : [],
                o = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : function (t, n) {
              return n;
            },
                i = n;
            return Object.keys(n).forEach(function (n) {
              t.traverseKey(n, i, r, o, e);
            }), i;
          }
        }, {
          key: "traverse",
          value: function value(n) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : function (t, n) {
              return n;
            };
            return t._traverse(n, null, [], e);
          }
        }]) && i(n, e), t;
      }(),
          c = {
        make: u.make,
        merge: u.merge,
        traverse: u.traverse
      };

      function a(t, n) {
        var e = {};
        return Object.keys(t).forEach(function (r) {
          c.make(r, t[r], e, n);
        }), e;
      }

      var s = {
        parse: a,
        createNodesAs: function createNodesAs(t) {
          return {
            parse: function parse(n, e) {
              return a(n, function (n, r, o) {
                var i = Object.assign(new t(), r);
                return e ? e(n, i, o) : i;
              });
            }
          };
        },
        find: function t(n) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              r = n.split("."),
              o = r.splice(0, 1);
          return 0 === r.length ? e[o] || null : t(r.join("."), e[o]);
        }
      };
      e.d(n, "tree", function () {
        return c;
      }), n.default = s;
    }]);
  }, function (t, n) {
    function e(t, n, e, r, o, i, u) {
      try {
        var c = t[i](u),
            a = c.value;
      } catch (t) {
        return void e(t);
      }

      c.done ? n(a) : Promise.resolve(a).then(r, o);
    }

    t.exports = function (t) {
      return function () {
        var n = this,
            r = arguments;
        return new Promise(function (o, i) {
          var u = t.apply(n, r);

          function c(t) {
            e(u, o, i, c, a, "next", t);
          }

          function a(t) {
            e(u, o, i, c, a, "throw", t);
          }

          c(void 0);
        });
      };
    };
  }, function (t, n) {
    t.exports = function (t) {
      if (Array.isArray(t)) {
        for (var n = 0, e = new Array(t.length); n < t.length; n++) {
          e[n] = t[n];
        }

        return e;
      }
    };
  }, function (t, n) {
    t.exports = function (t) {
      if (Symbol.iterator in Object(t) || "[object Arguments]" === Object.prototype.toString.call(t)) return Array.from(t);
    };
  }, function (t, n) {
    t.exports = function () {
      throw new TypeError("Invalid attempt to spread non-iterable instance");
    };
  }, function (t, n, e) {
    var r = function (t) {
      "use strict";

      var n,
          e = Object.prototype,
          r = e.hasOwnProperty,
          o = "function" == typeof Symbol ? Symbol : {},
          i = o.iterator || "@@iterator",
          u = o.asyncIterator || "@@asyncIterator",
          c = o.toStringTag || "@@toStringTag";

      function a(t, n, e, r) {
        var o = n && n.prototype instanceof y ? n : y,
            i = Object.create(o.prototype),
            u = new k(r || []);
        return i._invoke = function (t, n, e) {
          var r = f;
          return function (o, i) {
            if (r === p) throw new Error("Generator is already running");

            if (r === h) {
              if ("throw" === o) throw i;
              return L();
            }

            for (e.method = o, e.arg = i;;) {
              var u = e.delegate;

              if (u) {
                var c = E(u, e);

                if (c) {
                  if (c === v) continue;
                  return c;
                }
              }

              if ("next" === e.method) e.sent = e._sent = e.arg;else if ("throw" === e.method) {
                if (r === f) throw r = h, e.arg;
                e.dispatchException(e.arg);
              } else "return" === e.method && e.abrupt("return", e.arg);
              r = p;
              var a = s(t, n, e);

              if ("normal" === a.type) {
                if (r = e.done ? h : l, a.arg === v) continue;
                return {
                  value: a.arg,
                  done: e.done
                };
              }

              "throw" === a.type && (r = h, e.method = "throw", e.arg = a.arg);
            }
          };
        }(t, e, u), i;
      }

      function s(t, n, e) {
        try {
          return {
            type: "normal",
            arg: t.call(n, e)
          };
        } catch (t) {
          return {
            type: "throw",
            arg: t
          };
        }
      }

      t.wrap = a;
      var f = "suspendedStart",
          l = "suspendedYield",
          p = "executing",
          h = "completed",
          v = {};

      function y() {}

      function g() {}

      function d() {}

      var m = {};

      m[i] = function () {
        return this;
      };

      var b = Object.getPrototypeOf,
          x = b && b(b(P([])));
      x && x !== e && r.call(x, i) && (m = x);
      var w = d.prototype = y.prototype = Object.create(m);

      function O(t) {
        ["next", "throw", "return"].forEach(function (n) {
          t[n] = function (t) {
            return this._invoke(n, t);
          };
        });
      }

      function j(t) {
        var n;

        this._invoke = function (e, o) {
          function i() {
            return new Promise(function (n, i) {
              !function n(e, o, i, u) {
                var c = s(t[e], t, o);

                if ("throw" !== c.type) {
                  var a = c.arg,
                      f = a.value;
                  return f && "object" == typeof f && r.call(f, "__await") ? Promise.resolve(f.__await).then(function (t) {
                    n("next", t, i, u);
                  }, function (t) {
                    n("throw", t, i, u);
                  }) : Promise.resolve(f).then(function (t) {
                    a.value = t, i(a);
                  }, function (t) {
                    return n("throw", t, i, u);
                  });
                }

                u(c.arg);
              }(e, o, n, i);
            });
          }

          return n = n ? n.then(i, i) : i();
        };
      }

      function E(t, e) {
        var r = t.iterator[e.method];

        if (r === n) {
          if (e.delegate = null, "throw" === e.method) {
            if (t.iterator.return && (e.method = "return", e.arg = n, E(t, e), "throw" === e.method)) return v;
            e.method = "throw", e.arg = new TypeError("The iterator does not provide a 'throw' method");
          }

          return v;
        }

        var o = s(r, t.iterator, e.arg);
        if ("throw" === o.type) return e.method = "throw", e.arg = o.arg, e.delegate = null, v;
        var i = o.arg;
        return i ? i.done ? (e[t.resultName] = i.value, e.next = t.nextLoc, "return" !== e.method && (e.method = "next", e.arg = n), e.delegate = null, v) : i : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, v);
      }

      function S(t) {
        var n = {
          tryLoc: t[0]
        };
        1 in t && (n.catchLoc = t[1]), 2 in t && (n.finallyLoc = t[2], n.afterLoc = t[3]), this.tryEntries.push(n);
      }

      function _(t) {
        var n = t.completion || {};
        n.type = "normal", delete n.arg, t.completion = n;
      }

      function k(t) {
        this.tryEntries = [{
          tryLoc: "root"
        }], t.forEach(S, this), this.reset(!0);
      }

      function P(t) {
        if (t) {
          var e = t[i];
          if (e) return e.call(t);
          if ("function" == typeof t.next) return t;

          if (!isNaN(t.length)) {
            var o = -1,
                u = function e() {
              for (; ++o < t.length;) {
                if (r.call(t, o)) return e.value = t[o], e.done = !1, e;
              }

              return e.value = n, e.done = !0, e;
            };

            return u.next = u;
          }
        }

        return {
          next: L
        };
      }

      function L() {
        return {
          value: n,
          done: !0
        };
      }

      return g.prototype = w.constructor = d, d.constructor = g, d[c] = g.displayName = "GeneratorFunction", t.isGeneratorFunction = function (t) {
        var n = "function" == typeof t && t.constructor;
        return !!n && (n === g || "GeneratorFunction" === (n.displayName || n.name));
      }, t.mark = function (t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, d) : (t.__proto__ = d, c in t || (t[c] = "GeneratorFunction")), t.prototype = Object.create(w), t;
      }, t.awrap = function (t) {
        return {
          __await: t
        };
      }, O(j.prototype), j.prototype[u] = function () {
        return this;
      }, t.AsyncIterator = j, t.async = function (n, e, r, o) {
        var i = new j(a(n, e, r, o));
        return t.isGeneratorFunction(e) ? i : i.next().then(function (t) {
          return t.done ? t.value : i.next();
        });
      }, O(w), w[c] = "Generator", w[i] = function () {
        return this;
      }, w.toString = function () {
        return "[object Generator]";
      }, t.keys = function (t) {
        var n = [];

        for (var e in t) {
          n.push(e);
        }

        return n.reverse(), function e() {
          for (; n.length;) {
            var r = n.pop();
            if (r in t) return e.value = r, e.done = !1, e;
          }

          return e.done = !0, e;
        };
      }, t.values = P, k.prototype = {
        constructor: k,
        reset: function reset(t) {
          if (this.prev = 0, this.next = 0, this.sent = this._sent = n, this.done = !1, this.delegate = null, this.method = "next", this.arg = n, this.tryEntries.forEach(_), !t) for (var e in this) {
            "t" === e.charAt(0) && r.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = n);
          }
        },
        stop: function stop() {
          this.done = !0;
          var t = this.tryEntries[0].completion;
          if ("throw" === t.type) throw t.arg;
          return this.rval;
        },
        dispatchException: function dispatchException(t) {
          if (this.done) throw t;
          var e = this;

          function o(r, o) {
            return c.type = "throw", c.arg = t, e.next = r, o && (e.method = "next", e.arg = n), !!o;
          }

          for (var i = this.tryEntries.length - 1; i >= 0; --i) {
            var u = this.tryEntries[i],
                c = u.completion;
            if ("root" === u.tryLoc) return o("end");

            if (u.tryLoc <= this.prev) {
              var a = r.call(u, "catchLoc"),
                  s = r.call(u, "finallyLoc");

              if (a && s) {
                if (this.prev < u.catchLoc) return o(u.catchLoc, !0);
                if (this.prev < u.finallyLoc) return o(u.finallyLoc);
              } else if (a) {
                if (this.prev < u.catchLoc) return o(u.catchLoc, !0);
              } else {
                if (!s) throw new Error("try statement without catch or finally");
                if (this.prev < u.finallyLoc) return o(u.finallyLoc);
              }
            }
          }
        },
        abrupt: function abrupt(t, n) {
          for (var e = this.tryEntries.length - 1; e >= 0; --e) {
            var o = this.tryEntries[e];

            if (o.tryLoc <= this.prev && r.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
              var i = o;
              break;
            }
          }

          i && ("break" === t || "continue" === t) && i.tryLoc <= n && n <= i.finallyLoc && (i = null);
          var u = i ? i.completion : {};
          return u.type = t, u.arg = n, i ? (this.method = "next", this.next = i.finallyLoc, v) : this.complete(u);
        },
        complete: function complete(t, n) {
          if ("throw" === t.type) throw t.arg;
          return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && n && (this.next = n), v;
        },
        finish: function finish(t) {
          for (var n = this.tryEntries.length - 1; n >= 0; --n) {
            var e = this.tryEntries[n];
            if (e.finallyLoc === t) return this.complete(e.completion, e.afterLoc), _(e), v;
          }
        },
        catch: function _catch(t) {
          for (var n = this.tryEntries.length - 1; n >= 0; --n) {
            var e = this.tryEntries[n];

            if (e.tryLoc === t) {
              var r = e.completion;

              if ("throw" === r.type) {
                var o = r.arg;

                _(e);
              }

              return o;
            }
          }

          throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(t, e, r) {
          return this.delegate = {
            iterator: P(t),
            resultName: e,
            nextLoc: r
          }, "next" === this.method && (this.arg = n), v;
        }
      }, t;
    }(t.exports);

    try {
      regeneratorRuntime = r;
    } catch (t) {
      Function("r", "regeneratorRuntime = r")(r);
    }
  }, function (t, n, e) {
    "use strict";

    e.r(n);
    var r = e(5),
        o = e.n(r),
        i = e(1),
        u = e.n(i),
        c = e(2),
        a = e.n(c),
        s = e(6),
        f = e.n(s),
        l = e(4),
        p = e.n(l),
        h = e(0),
        v = e.n(h),
        y = e(7),
        g = e.n(y),
        d = e(3),
        m = e.n(d);

    function b(t, n, e) {
      var r = (Array.isArray(n) ? n : [n]).map(function (n) {
        return function (t, n, e) {
          if (void 0 === t) throw new Error("`instance` cannot be undefined");
          return t instanceof n ? {
            success: !0
          } : {
            success: !1,
            message: "".concat(e, " is not of required type ").concat(new n().constructor.name, ". It appears to be of type ").concat(t.constructor.name)
          };
        }(t, n, e);
      });
      return {
        success: r.filter(function (t) {
          return t.success;
        }).length > 0,
        messages: r.map(function (t) {
          return t.message;
        })
      };
    }

    function x(t, n, e) {
      var r = b(t, n, e);

      if (!r.success) {
        var o = r.messages.join(", ");
        throw new Error("Instance(s) is/are not of the appropriate type: ".concat(o));
      }
    }

    var w = function () {
      function t(n) {
        var e = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1],
            r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : t.MAX_TTL;
        u()(this, t), this.name = n, this.enabled = e, this.ttl = r, this.lastLoad = new Date();
      }

      return a()(t, [{
        key: "age",
        value: function value() {
          return (new Date() - this.lastLoad) / 1e3;
        }
      }, {
        key: "isExpired",
        value: function value() {
          return !!(!1 !== (this.ttl || !1) && this.age() > this.ttl) || !!this.parent && this.parent.isExpired();
        }
      }, {
        key: "isEnabled",
        value: function value() {
          return !1 !== this.enabled && (!this.parent || this.parent.isEnabled());
        }
      }, {
        key: "parent",
        set: function set(n) {
          null !== (n || null) && x(n, t, "value"), this._parent = n;
        },
        get: function get() {
          return this._parent;
        }
      }, {
        key: "fullName",
        get: function get() {
          return this.parent ? "".concat(this.parent.fullName, ".").concat(this.name) : this.name;
        }
      }], [{
        key: "default",
        value: function value(n) {
          return new t(n, !1);
        }
      }]), t;
    }();

    m()(w, "MAX_TTL", Number.MAX_SAFE_INTEGER);

    var O = function () {
      function t() {
        u()(this, t), m()(this, "match", null), m()(this, "entitlement", null);
      }

      return a()(t, null, [{
        key: "make",
        value: function value(n, e) {
          return Object.assign(new t(), {
            match: n,
            entitlement: e
          });
        }
      }]), t;
    }(),
        j = function () {
      function t() {
        u()(this, t), m()(this, "missing", null);
      }

      return a()(t, null, [{
        key: "make",
        value: function value(n, e) {
          return Object.assign(new t(), {
            matches: n,
            missing: e
          });
        }
      }]), t;
    }(),
        E = function () {
      function t() {
        u()(this, t), m()(this, "type", "one"), m()(this, "options", []);
      }

      return a()(t, [{
        key: "matches",
        value: function value(t) {
          var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : function () {
            return !0;
          };
          if (null == n) throw new Error("predicate is required");

          switch (this.type) {
            case "one":
              return this.__matchOne(this.options[0], t, n);

            case "any":
              return this.__matchAny(this.options, t, n);

            case "all":
              return this.__matchAll(this.options, t, n);

            default:
              throw new Error("Invalid query type. Valid types: 'one', 'any', 'all'");
          }
        }
      }, {
        key: "__matchOne",
        value: function value(t, n, e) {
          var r,
              o = this.__findRecursive(t, n);

          return o ? (x(o, w, "entitlement"), r = e(o) ? j.make([O.make(t, o)], []) : j.make([], [])) : r = j.make([], [t]), r;
        }
      }, {
        key: "__matchAny",
        value: function value(t, n, e) {
          var r = this;
          return t.map(function (t) {
            return r.__matchOne(t, n, e);
          }).reduce(function (t, n) {
            return Object.assign(j.make([], []), {
              matches: p()(t.matches || []).concat(p()(n.matches || [])),
              missing: p()(t.missing || []).concat(p()(n.missing || []))
            });
          }, new j());
        }
      }, {
        key: "__matchAll",
        value: function value(t, n, e) {
          var r = this.__matchAny(t, n, e),
              i = r.matches.filter(function (n, e, r) {
            return r.length === t.length && n.entitlement.enabled;
          });

          return r = o()({}, r, {
            matches: p()(i)
          });
        }
      }, {
        key: "__findRecursive",
        value: function value(t, n) {
          var e = n || this.entitlements;
          return f.a.find(t, e);
        }
      }], [{
        key: "create",
        value: function value(n) {
          return n instanceof t ? n : Array.isArray(n) ? Object.assign(new t(), {
            type: "any",
            options: n
          }) : n instanceof Object ? Object.assign(new t(), n) : Object.assign(new t(), {
            options: [n]
          });
        }
      }]), t;
    }();

    var S,
        _ = function () {
      function t(n, e) {
        u()(this, t), this.info("Created"), this.entitlements = n || {}, this.resolveEntitlementFn = e;
      }

      return a()(t, [{
        key: "isEntitled",
        value: function () {
          var t = g()(v.a.mark(function t(n) {
            return v.a.wrap(function (t) {
              for (;;) {
                switch (t.prev = t.next) {
                  case 0:
                    return t.abrupt("return", this.__isEntitled(E.create(n)));

                  case 1:
                  case "end":
                    return t.stop();
                }
              }
            }, t, this);
          }));
          return function (n) {
            return t.apply(this, arguments);
          };
        }()
      }, {
        key: "__isEntitled",
        value: function () {
          var t = g()(v.a.mark(function t(n) {
            var e,
                r,
                o,
                i = this;
            return v.a.wrap(function (t) {
              for (;;) {
                switch (t.prev = t.next) {
                  case 0:
                    if (n instanceof E) {
                      t.next = 2;
                      break;
                    }

                    throw new Error("query must be an instance of Query");

                  case 2:
                    return r = (e = function e() {
                      return n.matches(i.entitlements, function (t) {
                        return t.isEnabled();
                      });
                    })(), o = this.entitlements, t.next = 7, this.__resolveMissingAndExpired(r);

                  case 7:
                    return (o = t.sent) !== this.entitlements && (this.entitlements = o, r = e()), t.abrupt("return", r.matches.length > 0);

                  case 10:
                  case "end":
                    return t.stop();
                }
              }
            }, t, this);
          }));
          return function (n) {
            return t.apply(this, arguments);
          };
        }()
      }, {
        key: "__resolveMissingAndExpired",
        value: function () {
          var t = g()(v.a.mark(function t(n) {
            var e,
                r,
                i,
                u,
                c = this;
            return v.a.wrap(function (t) {
              for (;;) {
                switch (t.prev = t.next) {
                  case 0:
                    if (this.log("Resolving missing: ", n), 0 !== ((e = p()(n.missing).concat(p()(n.matches.filter(function (t) {
                      return t.entitlement.isExpired();
                    }).map(function (t) {
                      return t.entitlement.fullName;
                    })))) || []).length) {
                      t.next = 4;
                      break;
                    }

                    return t.abrupt("return", this.entitlements);

                  case 4:
                    return r = e.map(function () {
                      var t = g()(v.a.mark(function t(n) {
                        return v.a.wrap(function (t) {
                          for (;;) {
                            switch (t.prev = t.next) {
                              case 0:
                                return t.abrupt("return", c.__resolveMissingOrExpired(n));

                              case 1:
                              case "end":
                                return t.stop();
                            }
                          }
                        }, t);
                      }));
                      return function (n) {
                        return t.apply(this, arguments);
                      };
                    }()), t.next = 7, Promise.all(r);

                  case 7:
                    return i = t.sent, u = o()({}, this.entitlements), i.forEach(function (t) {
                      u = k.map(u, t);
                    }), t.abrupt("return", u);

                  case 11:
                  case "end":
                    return t.stop();
                }
              }
            }, t, this);
          }));
          return function (n) {
            return t.apply(this, arguments);
          };
        }()
      }, {
        key: "__resolveMissingOrExpired",
        value: function () {
          var t = g()(v.a.mark(function t(n) {
            var e;
            return v.a.wrap(function (t) {
              for (;;) {
                switch (t.prev = t.next) {
                  case 0:
                    if (this.log("resolveMissingOrExpired", n), !this.resolveEntitlementFn) {
                      t.next = 6;
                      break;
                    }

                    return t.next = 4, this.resolveEntitlementFn(n);

                  case 4:
                    return e = t.sent, t.abrupt("return", e || w.default(n));

                  case 6:
                    return t.abrupt("return", w.default(n));

                  case 7:
                  case "end":
                    return t.stop();
                }
              }
            }, t, this);
          }));
          return function (n) {
            return t.apply(this, arguments);
          };
        }()
      }]), t;
    }();

    (S = _).prototype.logger = !1, S.prototype.logLevel = "debug", S.prototype.log = function (t) {
      "debug" !== this.logLevel && "warn" !== this.logLevel && "info" !== this.logLevel || this.logger && this.logger.log("Entitlements:", t);
    }, S.prototype.warn = function (t) {
      "debug" !== this.logLevel && "warn" !== this.logLevel || this.logger && this.logger.warn("Entitlements:", t);
    }, S.prototype.info = function (t) {
      "info" === this.logLevel && this.logger && this.logger.info("Entitlements:", t);
    };

    var k = function () {
      function t() {
        u()(this, t);
      }

      return a()(t, null, [{
        key: "load",
        value: function value(t) {
          var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null,
              e = new _(null, n),
              r = f.a.createNodesAs(w).parse(t, function (t, n, e) {
            return Object.assign(n, {
              name: t,
              parent: e
            });
          });
          return e.entitlements = r, e;
        }
      }, {
        key: "map",
        value: function value(t, n) {
          var e = n;
          n instanceof w && ((e = {})[n.name] = o()({}, n));
          var r = f.a.createNodesAs(w).parse(e);
          return s.tree.merge(t, r);
        }
      }]), t;
    }();

    e.d(n, "EntitlementMapper", function () {
      return k;
    }), e.d(n, "Entitlement", function () {
      return w;
    }), e.d(n, "Query", function () {
      return E;
    }), e.d(n, "default", function () {
      return _;
    });
  }]);
});